import { rulePeriodicities } from './fixed-rules.js';
export const isRuleSimulationResponse = (value) => {
    if (typeof value !== 'object' || value === null)
        return false;
    const result = value;
    return (typeof result.member?.id === 'string' &&
        /^\d{4}-\d{2}$/.test(result.period ?? '') &&
        Array.isArray(result.items) &&
        result.items.every((item) => typeof item.ruleId === 'string' &&
            typeof item.unitAmount === 'string' &&
            Number.isInteger(item.quantity) &&
            typeof item.subtotal === 'string' &&
            (item.fromPeriod === null || typeof item.fromPeriod === 'string') &&
            (item.toPeriod === null || typeof item.toPeriod === 'string') &&
            Number.isInteger(item.aliquotCount) &&
            typeof item.amount === 'string' &&
            typeof item.applies === 'boolean' &&
            rulePeriodicities.includes(item.periodicity)) &&
        Number.isInteger(result.applicableCount) &&
        typeof result.totalAmount === 'string' &&
        result.writesPerformed === false &&
        typeof result.disclaimer === 'string');
};
